'use strict';
window.addEventListener("DOMContentLoaded", () => {
    //初回読み込み時に在庫チェック===========================================================================================
    const quantityEl = document.querySelector('.js-product-option-quantity');
    const cartBtn = document.querySelector(".js-product-form__submit");
    const cartBtnTxt = document.querySelector(".js-product-form__submit__txt");
    const el_option_quantity_text = document.querySelector('.js-product-option-quantity-text');
    //ボタンのテキストが「在庫なし」であるかを確認
    if (cartBtnTxt.textContent === '在庫なし') {
        quantityEl.classList.add("js-product-option-quantity--none");
        cartBtn.classList.add("js-product-form__submit--none");
        el_option_quantity_text.textContent = "なし";
    } else {
        el_option_quantity_text.textContent = "あり";
    }
    //option_update関数では、urlのパラメーターを読み取ってから動くため、デフォルトパラメータがない状態で反応しないため↑上記を記述
    option_update();
    // アプリが出力する再入荷通知の要素の監視を設定
    const productForm = document.getElementById("js-product-form-parent");
    const backInStockObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const backInStock = document.getElementById("_ngc_stock_notice_btn");
                if (backInStock) {
                    const cartBtn = document.querySelector(".js-product-form__submit");
                    if (cartBtn && backInStock.previousElementSibling !== cartBtn) {
                        // 要素がすでに適切な位置にない場合のみ移動
                        cartBtn.insertAdjacentElement('afterend', backInStock);
                        cartBtn.classList.add("js-product-form__submit--backInStock");
                        //placeholder を変更
                        const emailInput = document.getElementById('restock-email');
                        if (emailInput) {
                            emailInput.placeholder = "メールアドレスを入力";
                        }
                    }
                }
                console.log("再入荷通知ボタン処理実行");
                // 処理が完了したら監視を停止（disconnectすると表示されない時がある）
                // backInStockObserver.disconnect();
            }
        });
    });

    //監視対象を指定
    backInStockObserver.observe(productForm, { childList: true, subtree: true });

    //サムネイル画像のリストをドラッグで横スクロールできるようにする================================================================
    const slider = document.querySelector('.thumbnail-list');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault(); // テキスト選択を防止
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // スクロール速度を調整
        slider.scrollLeft = scrollLeft - walk;
    });

    //Size/Formがある場合に管理画面で登録した「正規式表記（補足表記）」を丸括弧を基準にして出し分ける処理================================
    if (document.getElementById("js-variantSizeName") != null) {
        let defaultSize = document.getElementById('js-variantSizeName');
        //liquid側で出力するデフォルトのSize/Formの名称を取得する
        let defaultSizeName = defaultSize.textContent;
        //URLのパラメーターを取得
        let searchParams = new URLSearchParams(window.location.search);
        //もし読み込み時点でバリエーションを選択状態だった場合
        if (searchParams.has('variant')) {
            defaultSize.classList.add("js-loaded");
        } else {
            //読み込み時点でデフォルトだった場合（variantのパラメーターがない場合）
            //デフォルト状態のSize/Formの名称の中に丸括弧が含まれていた場合「例：Glowの4000（〜8畳用）」
            if (defaultSizeName.indexOf("（") >= 0) {
                //正規表現で全角の「丸括弧の中だけ」を取り出して表示。「例：〜8畳用」
                let sizeNameJa = defaultSizeName.match(/（([^）]+)）/);
                defaultSize.textContent = sizeNameJa[1];
            }
            //js-loadedクラスを付与して表示
            defaultSize.classList.add("js-loaded");
        }
        // Size選択肢のinputには、丸括弧内の補足表記を消したいための処理==========================================================
        //選択肢のinputのlabelを全て取得
        let sizeLabelAll = document.querySelectorAll(".variantSize__blk__label");
        sizeLabelAll.forEach(function (sizeLabel) {
            //labelのテキストを変数に格納
            let sizeLabelTxt = sizeLabel.textContent;
            //丸括弧が含まれていた場合
            if (sizeLabelTxt.indexOf("（") >= 0) {
                //正規表現で全角丸括弧（補足表記）を削除「例：4000」
                sizeLabelTxt = sizeLabelTxt.replace((/（([^）]+)）/g), '');
            }
            //labelのテキストを書き換える
            sizeLabel.textContent = sizeLabelTxt;
            //js-loadedクラスを付与して表示
            sizeLabel.classList.add("js-loaded");
        });
    }

    //Instagramでインテリア例を見る========================================================================================
    const mainContentNodeForObserver = document.getElementById("MainContent");
    const observerConfigForThumbnails = { childList: true, subtree: true };

    const thumbnailsObserverCallback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const instagramLinkElement = document.getElementById("js-product__sns__btn--instagram");
                const thumbnailsContainerElement = document.getElementById("slpht-mobile-thumbnails-1");
                if (instagramLinkElement && thumbnailsContainerElement) {
                    observer.disconnect();  // 要素が見つかったらObserverを停止する

                    const firstThumbnailElement = thumbnailsContainerElement.querySelector(".slpht-thumbnail");
                    if (firstThumbnailElement) {
                        instagramLinkElement.addEventListener("click", function(event) {
                            event.preventDefault();
                            firstThumbnailElement.click();
                        });
                    }
                    break;
                }
            }
        }
    };
    const thumbnailsMutationObserver = new MutationObserver(thumbnailsObserverCallback);
    if (mainContentNodeForObserver) {
        thumbnailsMutationObserver.observe(mainContentNodeForObserver, observerConfigForThumbnails);
    }
});

window.addEventListener("load", () => {
    //数量セレクタ、カートボタン、お気に入りの移動==============================================================================
    // const formButtonsArea = document.getElementById("js-product-form__buttons");
    // const favoriteBtnMove = () => {
    //     let favoriteBtn = document.getElementById("wishlisthero-product-page-button-container");
    //     formButtonsArea.appendChild(favoriteBtn);
    //     favoriteBtn.classList.add("js-loaded");
    // }
    // //アプリで遅れて出力されるお気に入りボタンのタイミングが不明のため、保険でsetTimeoutで処理
    // setTimeout(favoriteBtnMove, 800);

    const formButtonsArea = document.getElementById("js-product-form__buttons");
    const favoriteBtnMove = () => {
        const favoriteBtn = document.getElementById("wishlisthero-product-page-button-container");
        if (favoriteBtn) {
            formButtonsArea.appendChild(favoriteBtn);
            favoriteBtn.classList.add("js-loaded");
            // 要素が見つかったらObserverを停止する
            favoriteBtnObserver.disconnect();
        }
    };
    //MutationObserverを使用してDOMの変化を監視
    const favoriteBtnObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                    if (node.id === "wishlisthero-product-page-button-container") {
                        favoriteBtnMove();
                    }
                });
            }
        });
    });
    //監視対象の設定
    const observerConfig = { childList: true, subtree: true };

    //.product-formが存在する場合のみ監視を開始
    const favoriteBtnParent = document.querySelector('.product-form');
    if (favoriteBtnParent) {
        favoriteBtnObserver.observe(favoriteBtnParent, observerConfig);
    }
    //初回実行
    favoriteBtnMove();

    //オプション料金のセレクトボックスの感知と移動==============================================================================
    const optionPriceArea = document.getElementById("js-product__info__price");

    const optionSelectChange = () => {
        if (document.querySelector(".gpo-total-text") != null) {
            //オプション料金を移動
            const optionPrice = document.querySelector(".gpo-total-text");
            if (!optionPriceArea.contains(optionPrice)) {
                optionPriceArea.appendChild(optionPrice);
            }
        }
        let optionSelectAll = document.querySelectorAll(".gpo-container select");
        optionSelectAll.forEach(function(optionSelect) {
            //セレクトボックスが変更されたタイミングで実行
            optionSelect.addEventListener('change', function() {
                const optionPrice = document.querySelector(".gpo-total-text");
                if (!optionPriceArea.contains(optionPrice)) {
                    optionPriceArea.appendChild(optionPrice);
                }
            });
        });
        //コード加工のセレクトボックスが存在していた場合------------------------------------------------------------------------
        if (document.querySelector(".js-gpoCustom-codeCover select") != null) {
            //お届け目安の要素を取得
            const deliveryDate = document.getElementById("js-product__info__delivery__cnt");
            //コード加工オプションのセレクトボックスを取得
            const codeCoverSelect = document.querySelector(".js-gpoCustom-codeCover select");
            codeCoverSelect.addEventListener('change', function(event) {
                if (event.target.value.includes("希望しない")) {
                    deliveryDate.textContent = "通常ご注文日の翌日〜1週間以内のお届け";
                } else {
                    deliveryDate.textContent = "ご注文日から約2〜3週間前後のお届け";
                }
            });

            //コード延長の長さ制限（最長値と最小値の設定）※Ex------------------------------------------------------------------
            //数値を入力するinput（.js-gpoCustom-codeEx .gpo-number）がある場合
            //※延長の場合にだけ適用されるように「.js-gpoCustom-codeEx」を設定
            //※カバーの有無だけのパターンが出てくるかもしれないためif文を設定
            //&&「aws_main-product.liquid」から「window.codeMaxLengths_ex」が渡ってきている場合に実行する
            const codeExLengthInput = document.querySelector(".js-gpoCustom-codeEx .gpo-number");
            if (codeExLengthInput) { // 要素が存在する場合のみ処理
                if (typeof window.codeMaxLengths_ex !== 'undefined') {
                    codeExLengthInput.setAttribute('data-max', window.codeMaxLengths_ex);
                }
                // コード延長用の最小値の設定
                if (typeof window.codeMinLengths_ex !== 'undefined') {
                    codeExLengthInput.setAttribute('data-min', window.codeMinLengths_ex);
                }
            }

            //コードカットの長さ制限（最長値と最小値の設定）※Cut----------------------------------------------------------------
            //数値を入力するinput（.js-gpoCustom-codeCut--max .gpo-number）がある場合
            //※カットの場合にだけ適用されるように「.js-gpoCustom-codeCut--max」を設定
            //※カバーの有無だけのパターンが出てくるかもしれないためif文を設定
            //&&「aws_main-product.liquid」から「window.codeMaxLengths_cut」が渡ってきている場合に実行する
            const codeCutLengthInput = document.querySelector(".js-gpoCustom-codeCut--max .gpo-number");
            if (codeCutLengthInput) { // 要素が存在する場合のみ処理
                if (typeof window.codeMaxLengths_cut !== 'undefined') {
                    codeCutLengthInput.setAttribute('data-max', window.codeMaxLengths_cut);
                }
                // コードカット用の最小値の設定
                if (typeof window.codeMinLengths_cut !== 'undefined') {
                    codeCutLengthInput.setAttribute('data-min', window.codeMinLengths_cut);
                }
            }
        }
    };

    //電球オプションのselect内の表記が1個あたりの価格が(¥+〜)で表示される。
    //4灯や6灯などの照明本体の場合、電球の数も4個や6個に設定しているため、
    //1個あたりの価格が表示されるとオプションの合計金額とselectの中の金額に矛盾が生じる。
    //保険で「〜電球 × 4個が追加されます」なども表示されるようにしているが、ユーザーが認識、理解しにくい。
    //そのため↓でselect内の「data-quantityの値（複数に設定している場合にだけ設定している固有の数値が表示される）」と(¥+〜)の価格を掛け算して書き換える処理を行う。
    const calculateAndUpdateOption = () => {
        const selectElement = document.querySelector('select[name="電球オプション"]');
        if (selectElement) {
            const quantityAttr = selectElement.getAttribute('data-quantity');
            if (quantityAttr && parseInt(quantityAttr, 10) >= 2) { // 10は10進数を指定
                const quantity = parseInt(quantityAttr, 10); // 10進数を指定
                const options = selectElement.querySelectorAll('option');

                options.forEach(option => {
                    const match = option.textContent.match(/\(\+ ¥([\d,]+)\)/);
                    if (match && !option.textContent.includes('合計')) { // 一度計算したオプションを再計算しない
                        const price = parseInt(match[1].replace(/,/g, ''), 10); // 10進数を指定
                        if (!isNaN(price)) {
                            const total = quantity * price;
                            option.textContent = option.textContent.replace(/\(\+ ¥[\d,]+\)/, `(合計 ¥${total.toLocaleString()})`);
                        }
                    }
                });
            }
        }
    };

    const init = () => {
        // 初回実行
        calculateAndUpdateOption();
        optionSelectChange(); // 初回に optionSelectChange を呼び出してオプション価格を反映

        //gpoContainerNodeを監視対象にする
        //.gpo-containerがあれば、その中で起こる変化を監視し、なければbody全体の変化を監視
        const gpoContainerNode = document.querySelector(".gpo-container") || document.body;
        const optionMutationObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    //.gpo-total-textが現れた場合、optionSelectChange()を実行する
                    if (document.querySelector(".gpo-total-text") != null) {
                        optionSelectChange();
                    }
                    //select[name="電球オプション"]が現れた場合、calculateAndUpdateOption()を実行する
                    if (document.querySelector('select[name="電球オプション"]') != null) {
                        calculateAndUpdateOption();
                    }
                }
            }
        });

        if (gpoContainerNode) {
            optionMutationObserver.observe(gpoContainerNode, { childList: true, subtree: true });
        }
    };
    // `DOMContentLoaded`リスナーは不要です。初回実行と監視をここで行います。
    init();

    //商品紹介アコーディオン================================================================================================
    const productLead__in = document.getElementById("js-product__btm__lead__txt__in");
    const productLead__in_height = productLead__in.offsetHeight;
    if (productLead__in_height >= 260) {
        const productLead_more = document.getElementById("js-product__btm__lead__txt__more");
        productLead_more.classList.add("js-product__btm__lead__txt__more--show");
        productLead_more.addEventListener('click', () => {
            productLead__in.classList.add("js-product__btm__lead__txt__in--open");
            productLead_more.classList.add("js-product__btm__lead__txt__more--hide");
        });
    }

    //カートに入れるボタンを下部に移動&固定====================================================================================
    const pdBtm = document.getElementById("js-product__btm");
    const productForm = document.getElementById("js-product-form-parent");
    let currentScroll = window.scrollY;
    let pdBtmTop = pdBtm.offsetTop - 50;
    if (currentScroll >= pdBtmTop) {
        productForm.classList.add("js-product-form-parent--fixed");
    } else {
        productForm.classList.remove("js-product-form-parent--fixed");
    }
    //フッター取得
    const footer = document.getElementById("js-footer");
    let footerTop = footer.offsetTop;
    //ウィンドウの内部の高さ
    let windowHeight = window.innerHeight;

    function cartBtn_footer_hide() {
        footerTop = footer.offsetTop;

        // SP：固定カートを隠す（既存）
        if (window.matchMedia('(max-width: 1023px)').matches) {
            if ((currentScroll + windowHeight) >= footerTop) {
                productForm.classList.add("js-product-form-parent--hide");
                // productForm.classList.remove("js-product-form-parent--fixed");
            } else {
                productForm.classList.remove("js-product-form-parent--hide");
            }
        }
    }

    cartBtn_footer_hide();
    addEventListener("resize", cartBtn_footer_hide);
    //scroll時の処理
    let ticking = false;
    function cartBtn_fixHide() {
        currentScroll = window.scrollY;
        pdBtmTop = pdBtm.offsetTop - 50;
        if (currentScroll >= pdBtmTop) {
            productForm.classList.add("js-product-form-parent--fixed");
        } else {
            productForm.classList.remove("js-product-form-parent--fixed");
        }
        cartBtn_footer_hide();
        ticking = false;
    }
    function cartBtn_ticking() {
        if (!ticking) {
            requestAnimationFrame(cartBtn_fixHide);
            ticking = true;
        }
    }
    addEventListener("scroll", cartBtn_ticking);

    //カートに入れるボタンPC時に上部に移動&固定================================================================================
    const productForm_pcFixedArea = document.getElementById("js-product-form__pcFixed");
    const productForm_pcFixedArea__en = document.getElementById("js-product-form__pcFixed__en");
    const productForm_pcFixedArea__ja = document.getElementById("js-product-form__pcFixed__ja");
    const productForm_pcFixedArea__price = document.getElementById("js-product-form__pcFixed__price");
    const productPriceElement = document.querySelector(".js-product__info__price__left");

    productForm_pcFixedArea__en.textContent = document.getElementById("js-product__info__ttl__en").textContent;
    productForm_pcFixedArea__ja.textContent = document.getElementById("js-product__info__ttl__ja").textContent;

    //初期価格をクローンして表示
    let productPriceClone = productPriceElement.cloneNode(true);
    productForm_pcFixedArea__price.appendChild(productPriceClone);

    //価格をクローンする関数
    function variantChangePrice() {
        //既に価格が存在していた場合は削除
        const existingPrice = productForm_pcFixedArea__price.querySelector(".js-product__info__price__left");
        if (existingPrice) {
            existingPrice.remove();
        }
        //クローンして追加
        productPriceClone = productPriceElement.cloneNode(true);
        productForm_pcFixedArea__price.appendChild(productPriceClone);
    }

    // Paidyウィジェットの価格を選択中バリエーションに合わせて更新
    function updatePaidyPrice() {
        const paidyWidget = document.querySelector('._paidy-promotional-messaging');

        // Paidyウィジェットがない場合は何もしない
        if (!paidyWidget) return;

        // 現在の商品セクションを取得
        const productInfo = document.querySelector('product-info[data-section]');
        if (!productInfo) return;

        const sectionId = productInfo.dataset.section;

        // この商品専用のproduct formからvariant IDを取得
        const productForm = document.getElementById(`product-form-${sectionId}`);
        if (!productForm) return;

        const variantInput = productForm.querySelector('input[name="id"]');
        if (!variantInput) return;

        const variantId = Number(variantInput.value);

        // variant picker内の商品バリエーションJSONを取得
        const variantJson = document.querySelector(
            'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
        );
        if (!variantJson) return;

        let variants;

        try {
            variants = JSON.parse(variantJson.textContent);
        } catch (error) {
            console.error('Paidy: variant JSONの取得に失敗しました', error);
            return;
        }

        const currentVariant = variants.find(
            variant => Number(variant.id) === variantId
        );

        if (!currentVariant) return;

        // Shopifyのpriceは100倍された値なので円に戻す
        const price = currentVariant.price / 100;

        // Paidyに選択中variantの価格を設定
        paidyWidget.setAttribute('data-amount', price);

        // Paidyウィジェットを再描画
        if (typeof _paidy !== 'undefined') {
            _paidy('pm:refresh');
        }
    }

    //価格の変更を監視するMutationObserver
    // const priceObserver = new MutationObserver((mutations) => {
    //     mutations.forEach((mutation) => {
    //         if (mutation.type === 'childList' || mutation.type === 'characterData') {
    //             // 価格が変更された場合に実行
    //             variantChangePrice();
    //         }
    //     });
    // });
    const priceObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                // 価格が変更された場合に実行
                variantChangePrice();

                // Paidyウィジェットも選択中variantの価格に更新
                updatePaidyPrice();
            }
        });
    });

    //監視の開始
    priceObserver.observe(productPriceElement, {
        childList: true, // 直接の子ノードの追加や削除を監視
        characterData: true, // テキストノードの内容の変更を監視
        subtree: true // すべての子孫ノードの変更も監視
    });

    //FEATURE内のvideoタグの動画がSizeやColorを変更すると停止してしまうための制御================================================
    const featureVideo = document.getElementById("js-c-features__cnt__sec__images__swiper__img--video");
    const featureVideo_play = (featureVideo) => {
        if (featureVideo) {
            const videoSrc = featureVideo.getAttribute('data-src');
            if (videoSrc) {
                // data-src を src に設定
                featureVideo.setAttribute('src', videoSrc);
                featureVideo.load(); // 動画の読み込みを再開始

                // 動画の再生を canplay イベント後に実行
                featureVideo.addEventListener('canplay', () => {
                    if (featureVideo.paused) {
                        featureVideo.play().then(() => {
                            console.log("動画が再生されました");
                        }).catch(error => {
                            console.error("動画再生エラー:", error);
                        });
                    }
                }, { once: true }); // イベントリスナーは1回だけ実行
            } else {
                console.error("data-src 属性が見つかりません");
            }
        }
    };
    // 初回ロード時に動画を再生
    featureVideo_play(featureVideo);

    //サイズの選択の変化に伴う制御===========================================================================================
    const selectSizeAll = document.querySelectorAll("#js-variantSize input");
    if (selectSizeAll.length > 0) {
        selectSizeAll.forEach((selectSize) => {
            selectSize.addEventListener('change', () => {
                variantChangePrice();//サイズ変更時に価格を更新
                featureVideo_play(featureVideo);//サイズ変更時にFEATURE内のvideoタグの動画を再生
            });
        });
    }

    //カラーの選択の変化に伴う制御===========================================================================================
    const selectColorAll = document.querySelectorAll("#js-variantColors input");
    selectColorAll.forEach((selectColor) => {
        if (selectColor.checked) {
            const selectColorImgClone = selectColor.nextElementSibling.firstElementChild.cloneNode(true);
            productForm_pcFixedArea.insertBefore(selectColorImgClone, productForm_pcFixedArea__en);
        }
        selectColor.addEventListener('change', () => {
            selectColorAll.forEach((color) => {
                if (color.checked) {
                    const existingColorImage = document.querySelector("#js-product-form__pcFixed .variantColors__blk__label__img");
                    if (existingColorImage) {
                        existingColorImage.remove();
                    }
                    const selectColorImgClone = color.nextElementSibling.firstElementChild.cloneNode(true);
                    productForm_pcFixedArea.insertBefore(selectColorImgClone, productForm_pcFixedArea__en);

                    //カラー変更時にFEATURE内のvideoタグの動画を再生
                    featureVideo_play(featureVideo);
                }
            });
            // バリエーションの変更で価格が変わる場合があるため変更時に価格を再度Cloneして削除して移動
            variantChangePrice();
        });
    });

    //スライダーのサムネイルのクリック時にも動画が停止するのでfeatureVideo_playを実行==============================================
    const thumbnailItems = document.querySelectorAll(".thumbnail-list__item");
    if (thumbnailItems.length > 0) { // 要素が存在する場合のみ処理を実行
        thumbnailItems.forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
                featureVideo_play(featureVideo);
            });
        });
    }

});

let now_option_id = '';
const timer_option_update = setInterval(option_update, 500);
//オプション選択状況を定期調査し、コンテンツ置き換え
function option_update() {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('variant')) {
        let variant_id = searchParams.get('variant');
        if (now_option_id !== variant_id) {
            // console.log('オプションの変更を感知しました');
            //商品番号を変更
            let el_option_sku = document.getElementById('js-variantSku');
            el_option_sku.textContent = arr_varis[variant_id].sku;
            //Sizeがある場合の処理
            if (document.getElementById("js-variantSizeName") != null) {
                let el_size_name = document.getElementById('js-variantSizeName');
                if (arr_varis[variant_id].option1.indexOf("（") >= 0) {
                    //正規表現で全角括弧の中を取り出す
                    let sizeNameJa = arr_varis[variant_id].option1.match(/（([^）]+)）/);
                    el_size_name.textContent = sizeNameJa[1];
                } else {
                    el_size_name.textContent = arr_varis[variant_id].option1;
                }
                //Colorを変更（Sizeがある場合はoption2になる）
                let el_color_name = document.getElementById('js-variantColorName');
                el_color_name.textContent = arr_varis[variant_id].option2;
            } else {
                //Colorを変更（Sizeがない場合はoption1になる）
                let el_color_name = document.getElementById('js-variantColorName');
                el_color_name.textContent = arr_varis[variant_id].option1;
            }
            //在庫数に応じた表示制御
            const el_option_quantity_text = document.querySelector('.js-product-option-quantity-text');
            const quantityEl = document.querySelector('.js-product-option-quantity');
            const cartBtn = document.querySelector(".js-product-form__submit");
            const cartBtnTxtAll = document.querySelectorAll(".js-product-form__submit__txt");
            if (arr_varis[variant_id].stock > 0) {
                //在庫状況
                let text_stock = '';
                if (arr_varis[variant_id].stock > 5) {
                    text_stock = 'あり';
                } else {
                    text_stock = '残りわずか';
                }
                el_option_quantity_text.textContent = text_stock;
                //数量ボタン
                quantityEl.classList.remove("js-product-option-quantity--none");
                //カートボタン
                cartBtn.classList.remove("js-product-form__submit--none");
                //カートボタンのテキスト
                cartBtnTxtAll.forEach(function(cartBtnTxt) {
                    cartBtnTxt.textContent = "カートに追加する";
                });
            } else {
                el_option_quantity_text.textContent = "なし";
                //数量ボタン
                quantityEl.classList.add("js-product-option-quantity--none");
                //カートボタン
                cartBtn.classList.add("js-product-form__submit--none");
                //カートボタンのテキスト
                cartBtnTxtAll.forEach(function(cartBtnTxt) {
                    cartBtnTxt.textContent = "在庫なし";
                });
            }
            now_option_id = variant_id;
        }
    }
}

//1:1動画スライドを切り替えた際に停止、動画に戻った際に再生==================================================================
// Shopifyの定義に合わせた、シンプルな動画再生制御JS
window.addEventListener("DOMContentLoaded", () => {
    const thumbnailsContainer = document.querySelector('.thumbnail-list');
    const mainSlides = document.querySelectorAll('.product__media-item[data-media-id]');
    if (!thumbnailsContainer || !mainSlides.length) return;

    let previousVideo = null;

    const playVideo = (video, reset = false) => {
        if (!video) return;
        if (reset) video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;
        requestAnimationFrame(() => {
            const p = video.play();
            if (p?.catch) p.catch(() => video.play());
        });
    };

    const handleSwitch = () => {
        const activeThumb = thumbnailsContainer.querySelector('button[aria-current="true"]');
        if (!activeThumb) return;

        const targetId = activeThumb.closest('li')?.dataset.target;
        if (!targetId) return;

        const currentSlide = document.querySelector(`.product__media-item[data-media-id="${targetId}"]`);
        if (!currentSlide) return;

        const currentVideo = currentSlide.querySelector('video');

        // 前の動画を停止
        if (previousVideo && previousVideo !== currentVideo && !previousVideo.paused) {
            previousVideo.pause();
        }

        // 新しい動画があれば再生
        if (currentVideo && currentVideo.paused) {
            playVideo(currentVideo);
            previousVideo = currentVideo;
        }
    };

    const observer = new MutationObserver(handleSwitch);
    observer.observe(thumbnailsContainer, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-current']
    });

    thumbnailsContainer.addEventListener('click', (e) => {
        const button = e.target.closest('button');
        if (!button) return;

        const targetId = button.closest('li')?.dataset.target;
        if (!targetId) return;

        const currentSlide = document.querySelector(`.product__media-item[data-media-id="${targetId}"]`);
        if (!currentSlide) return;

        const video = currentSlide.querySelector('video');

        if (!video) {
            if (previousVideo && !previousVideo.paused) {
                previousVideo.pause();
            }
            return;
        }

        if (video === previousVideo) {
            // 同じ動画サムネイルを再度タップ ⇒ 最初から再生
            playVideo(video, true);
        } else {
            if (previousVideo && !previousVideo.paused) {
                previousVideo.pause();
            }
            playVideo(video);
            previousVideo = video;
        }
    });
});





